import React from "react";
import { connect } from "react-redux";

import { MenuItem } from "../../types/system/MenuItem";
import { IAppState } from "../../state/Store";
import { CustomConfigSection } from "../../state/system/Menu";
import ApplicationState from "../../foundation/AppState";
import Configuration from "../../foundation/Configuration";

import "./SettingsMenu.scss";

interface SettingsMenuProps {
    open: boolean;
    generalItems: MenuItem[];
    configItems: MenuItem[];
    customSections: CustomConfigSection[];
}

class SettingsMenu extends React.Component<SettingsMenuProps> {
    itemClicked = (item: MenuItem) => {
        if (item.onClick) {
            item.onClick();
        } else if (item.path) {
            window.location.href = item.path;
        }
    };

    render(): React.ReactNode {
        return (
            this.props.open && (
                <div className="apps-menu-slide">
                    <div className="sidebar-menu apps-menu">
                        <div className="config-links app-items buttons">
                            {this.props.generalItems.length > 0 && (
                                <div>
                                    <span className="title">
                                        General Settings
                                    </span>

                                    <div className="items">
                                        {this.props.generalItems.map(
                                            (item, index) => (
                                                <button
                                                    key={index}
                                                    className={`item${
                                                        item.emphasize
                                                            ? " emphasize"
                                                            : ""
                                                    }`}
                                                    onClick={() =>
                                                        this.itemClicked(item)
                                                    }>
                                                    <div className="icon-cont">
                                                        <i>{item.icon}</i>
                                                    </div>

                                                    <span>{item.name}</span>
                                                </button>
                                            ),
                                        )}
                                    </div>
                                </div>
                            )}

                            {this.props.configItems.length > 0 && (
                                <div>
                                    <span className="title">
                                        Configuration Settings
                                    </span>

                                    <div className="items">
                                        {this.props.configItems.map(
                                            (item, index) => (
                                                <button
                                                    key={index}
                                                    className={`item${
                                                        item.emphasize
                                                            ? " emphasize"
                                                            : ""
                                                    }`}
                                                    onClick={() =>
                                                        this.itemClicked(item)
                                                    }>
                                                    <div className="icon-cont">
                                                        <i>{item.icon}</i>
                                                    </div>

                                                    <span>{item.name}</span>
                                                </button>
                                            ),
                                        )}
                                    </div>
                                </div>
                            )}

                            {this.props.customSections.map((section, index) => (
                                <div key={index}>
                                    <span className="title">
                                        {section.name}
                                    </span>

                                    <div className="items">
                                        {section.items.map((item, index) => (
                                            <button
                                                key={index}
                                                className={`item${
                                                    item.emphasize
                                                        ? " emphasize"
                                                        : ""
                                                }`}
                                                onClick={() =>
                                                    this.itemClicked(item)
                                                }>
                                                <div className="icon-cont">
                                                    <i>{item.icon}</i>
                                                </div>

                                                <span>{item.name}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="version-container">
                            App Version: {Configuration.version}
                            <br />
                            Platform Version: {Configuration.platformVersion}
                        </div>

                        <div className="legal-container">
                            <a
                                target="_blank"
                                rel="noreferrer noopener"
                                href="https://www.timetabling.com.au/support/kb/1000256393">
                                Privacy
                            </a>{" "}
                            |
                            <a
                                target="_blank"
                                rel="noreferrer noopener"
                                href="https://www.timetabling.com.au/support/kb/1000256396">
                                Subscription Agreement
                            </a>
                        </div>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        generalItems: ApplicationState.instance.generalItems,
        configItems: ApplicationState.instance.configItems,
        customSections: ApplicationState.instance.customSections,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsMenu);
